import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useTellescopeQuery } from "@tellescope/tanstack-query";
import { formatName } from "@tellescope/utils";
import { NavTakeoverCard } from "./NavTakeoverCard";
import { useReopenSidebarAction } from "../../pages/contacts/useReopenSidebarAction";

export const ContactTimelineTakeoverCard = () => {
  const { t } = useTranslation("contacts");
  const { enduserId } = useParams();

  const { data: enduser } = useTellescopeQuery({
    model: "endusers",
    method: "getOne",
    request: enduserId ?? "",
    enabled: !!enduserId,
  });

  const reopenAction = useReopenSidebarAction(enduserId ?? "");

  return (
    <NavTakeoverCard
      title={enduser ? formatName(enduser) : t("Contact")}
      description={t("Now viewing: {{blockName}}", { blockName: t("Timeline") })}
      onTitleClick={reopenAction?.onClick}
    />
  );
};
